module.exports = __webpack_public_path__ + "static/img/stair-Img.1778636131768.png";